import { render, staticRenderFns } from "./NestedVariable.vue?vue&type=template&id=5a9a5615&scoped=true"
import script from "./NestedVariable.vue?vue&type=script&lang=js"
export * from "./NestedVariable.vue?vue&type=script&lang=js"
import style0 from "./NestedVariable.vue?vue&type=style&index=0&id=5a9a5615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a5615",
  null
  
)

export default component.exports